import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';
import {
  ISSUER_NAME,
  PARENT_NAME,
  RATING_AGENCY_NAME,
  UNDERWRITER_NAME,
} from '@/creditflowresearch/ui/components/TopCompanies/constants';

interface IProps {
  activeTab: string,
  onClick: (tabName: string) => void,
  isCorporate: boolean,
}

const getOptions = (isCorporate: boolean): ISelectOption[] => [
  { label: 'Issuers', value: isCorporate ? PARENT_NAME : ISSUER_NAME },
  { label: 'Rating Agencies', value: RATING_AGENCY_NAME },
  { label: 'Underwriters', value: UNDERWRITER_NAME },
];

const TopCompaniesTabSelect = ({ activeTab, onClick, isCorporate }: IProps) => {
  const options = getOptions(isCorporate);
  const value = options.find((o) => o.value === activeTab) || options[0];

  const handleChange = (option: ISelectOption): void => {
    if (option) {
      onClick(option.value as string);
    }
  };

  return (
    <Select
      value={ value }
      options={ options }
      onChange={ handleChange }
      isSlim
      isNarrow
      isSearchable={ false }
      size="S"
      dataTest="topCompaniesTabSelect"
    />
  );
};

export default TopCompaniesTabSelect;
